module.exports = __webpack_public_path__ + "img/k0RSXoBZux.ee229650.png";